import React, { Component } from "react";
import { Media, Player } from "react-media-player";
import PlayPause from "./play_pause";
import SeekBar from "./seek_bar";
import ContextMenu from "../context_menu";
import { If } from "react-extras";
import "./media_player.scss";
import get from "lodash/get";
import { MediaFileActionManager } from "../../../action_managers/shows";
import { connect } from "react-redux";
import { Icon } from "../icon";
import InfoTooltip from "../info";

class MediaPlayer extends Component {
  componentDidMount() {
    const { fetchMediaFile, mediaFile, mediaFileURL, mediaFileUUID } = this.props;

    if (!mediaFile && !mediaFileURL && mediaFileUUID) {
      fetchMediaFile(mediaFileUUID);
    }
  }

  getURL = () => {
    if (this.props.mediaFileURL) {
      return this.props.mediaFileURL;
    }
    var mediaFileUUID = this.props.mediaFileUUID;

    var mediaFile;
    if (this.props.mediaFile) {
      mediaFile = this.props.mediaFile;
    } else if (this.props.mediaFiles[mediaFileUUID]) {
      mediaFile = this.props.mediaFiles[mediaFileUUID];
    }

    return get(mediaFile, "convertedURL");
  };

  renderDisabled = () => <Icon iconName="playBlack" disabled name={"play"} />;

  render() {
    let URL = this.getURL();

    return (
      <div>
        {URL && (
          <Media>
            <div className="media-player-wrapper">
              <div className="media-player">
                <Player
                  src={URL}
                  onTimeUpdate={status => {
                    if (this.props.setCursor) {
                      this.props.setCursor(status.currentTime);
                    }
                  }}
                  onPause={status => {
                    if (this.props.setCursor) {
                      this.props.setCursor(status.currentTime);
                    }
                  }}
                />
              </div>
              <div className={`media-player__media-controls  ${this.props.mini ? "mini" : ""}`}>
                {this.props.children && this.props.children(this.props)}
                <div className={"media-player__play-pause_wrapper"}>
                  {this.props.disabled ? this.renderDisabled() : <PlayPause />}
                </div>
                {this.props.infoBitText && (
                  <div className={"media-player__info-bit-wrapper"}>
                    <InfoTooltip helpText={this.props.infoBitText} />
                  </div>
                )}
                {!this.props.mini && (
                  <>
                    <div className="media-player__seek-bar">
                      <SeekBar />
                    </div>
                    <If condition={Boolean(this.props.menuItems)}>
                      <div className="media-player__context-menu">
                        <ContextMenu menuItems={this.props.menuItems} />
                      </div>
                    </If>
                  </>
                )}
              </div>
            </div>
          </Media>
        )}
      </div>
    );
  }
}

export default connect(state => ({ mediaFiles: state.mediaFiles }), {
  fetchMediaFile: (mediaFileUUID, authToken) => {
    if (mediaFileUUID) {
      return new MediaFileActionManager({ mediaFileUUID, authToken }).run();
    }
  },
})(MediaPlayer);
